export default __webpack_public_path__ + "static/media/30.8a2afa04.jpg";